import React, {useState} from "react";
import {useFormik} from "formik";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {Grid} from "@mui/system";
import style from "../../assets/css/login-register.module.scss";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
} from "@mui/material";
import GlobalTextField from "../global-fields/GlobalTextField";
import GlobalPassword from "../global-fields/GlobalPassword";
import {Link} from "react-router-dom";
import {LOGIN_USER} from "../../constants/apiConstant";
import {useDispatch, useSelector} from "react-redux";
import {setAuthData} from "../../store/authSlice";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {removeCookies, setCookies} from "../../constants/helper";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {dynamicHeaderHeight} = useSelector(selectUiState);

  const [rememberMe, setRememberMe] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);

  let initialFormikVals = {
    email: "",
    password: "",
  };

  const handleLogin = async (e) => {
    // setIsLoading(true)
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {...e};
    // let data = { ...e, remember_me: rememberMe };

    const options = {
      method: LOGIN_USER.method,
      headers: LOGIN_USER.headers,
      body: JSON.stringify(data),
    };

    fetch(LOGIN_USER.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          // setIsLoading(false)
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          GlobalNotificationPopup({type: "error", message: res?.message});
          removeCookies("isLogin");
        } else if (res.status == 1) {
          GlobalNotificationPopup({type: "success", message: res?.message});
          if (rememberMe && res?.user_id) {
            // setCookies("saib_token", res.token);
            setCookies("saib_uid", `saib_${res?.user_id}`);
          } else {
            // removeCookies("saib_token");
            removeCookies("saib_uid");
          }

          dispatch(
            setAuthData({
              user_id: res?.user_id,
            })
          );
          // setIsLoading(false)
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          setCookies("isLogin", "true");
          navigate(`/verification/otp/${res?.user_id}`);
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        // setIsLoading(false);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues: initialFormikVals,
    onSubmit: (values) => {
      handleLogin(values);
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .email("Must be a valid email.")
        .required("Email is required!"),
      password: yup
        .string()
        .trim()
        .required("Password is required!")
        .min(8, "Password must have at least 8 characters."),
    }),
  });
  return (
    <>
      <div
        className={style.logMainWrapper}
        style={{height: `calc(100vh - ${dynamicHeaderHeight}px)`}}
      >
        <div className={style.logLeftMain}>
          <Grid container spacing={1} justifyContent="center">
            <Grid size={{xs: 12, lg: 7, xl: 6}}>
              <div className={style.log_title}>
                <h2> Login </h2>
                <p> Enter your credentials to access your account </p>
              </div>

              <form
                autoComplete="false"
                autoSave="false"
                onSubmit={formik.handleSubmit}
              >
                <Grid container spacing={1} justifyContent="center">
                  <Grid size={{xs: 12, lg: 12}} className={style.logLabel}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Email address
                    </InputLabel>

                    <GlobalTextField
                      id="email"
                      name="email"
                      type="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>

                  <Grid
                    size={{xs: 12, lg: 12}}
                    sx={{mt: 2}}
                    className={style.logLabel}
                  >
                    <div className={style.logPassField}>
                      <InputLabel
                        sx={{mb: 1}}
                        htmlFor="outlined-adornment-password"
                        style={{color: "black"}}
                      >
                        Password
                      </InputLabel>
                      <FormControl fullWidth variant="outlined">
                        <GlobalPassword
                          id="password"
                          name="password"
                          type="password"
                          value={formik.values.password}
                          onChange={(e) =>
                            formik.setFieldValue("password", e.target.value)
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.password &&
                            Boolean(formik.errors.password)
                          }
                          helperText={
                            formik.touched.password && formik.errors.password
                          }
                        />
                      </FormControl>
                    </div>
                  </Grid>

                  <Grid size={{xl: 12, xs: 12}}>
                    <div className={style.log_checkbox}>
                      {/* <FormControlLabel
                        className={style.LogRemember}
                        control={
                          <Checkbox
                            value={rememberMe}
                            onChange={(e) => {
                              setRememberMe(e.target.checked);
                            }}
                          />
                        }
                        label="Remember Me"
                      /> */}
                      <Link to="/forgot-password">Forgot Password?</Link>
                    </div>
                    <div className={style.logBtnMain}>
                      <Button fullWidth variant="contained" type="submit">
                        Login
                      </Button>
                      <p>
                        Don't have an account?{" "}
                        <Link to="/register">Register</Link>
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </div>
        {/* Back image div start */}
        <div className={style.logRightMain}>
          <div className={style.logRightWrapper}></div>
        </div>
        {/* Back image div end */}
      </div>
    </>
  );
};

export default Login;
